import Button from '@jetbrains/ring-ui/components/button/button'
import ButtonSet from '@jetbrains/ring-ui/components/button-set/button-set'
import {memo} from 'react'

import {useAppDispatch} from '../../../../../hooks/react-redux'
import useEventCallback from '../../../../../hooks/useEventCallback'
import {parameterGroups} from '../../Parameters.slice'

interface Props {
  className?: string
}

function ParametersGroupControlsComponent({className}: Props) {
  const dispatch = useAppDispatch()

  const onExpandAllClick = useEventCallback(() => {
    dispatch(parameterGroups.actions.expandAll())
  })
  const onCollapseAllClick = useEventCallback(() => {
    dispatch(parameterGroups.actions.collapseAll())
  })

  return (
    <ButtonSet className={className} data-test-parameters-group="controls">
      <Button onClick={onExpandAllClick} data-test-control={'expand'}>
        {'Expand All'}
      </Button>
      <Button onClick={onCollapseAllClick} data-test-control={'collapse'}>
        {'Collapse All'}
      </Button>
    </ButtonSet>
  )
}

export const ParametersGroupControls = memo<Props>(ParametersGroupControlsComponent)
